module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark-5200c2378b3fa9c00a3f3434345ad9c7.png";